import { PermissionT } from "../types";

export const projectManagement = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "project_management");
  return !!p;
};

export default projectManagement;
